import { Button, Icon, Modal } from "@legal-500/legal500-design-system";
import styles from "./Modal.module.css";

type DragErrorModalProps = {
  message: string;
  onClose: () => void;
};

export function DragErrorModal({ message, onClose }: DragErrorModalProps) {
  return (
    <Modal isOpen onClose={onClose} title="Cannot Move Item" size="small">
      <div className={styles.modalContent}>
        <div className={styles.dragError}>
          <Icon icon="exclamation" size="large" className={styles.errorIcon} />
          <p className={styles.errorText}>{message}</p>
        </div>
      </div>
      <div className={styles.modalFooterButtons}>
        <Button onClick={onClose} variant="contained" color="primary">
          OK
        </Button>
      </div>
    </Modal>
  );
}
